import { render, staticRenderFns } from "./PowerDistribution.vue?vue&type=template&id=36d58fcc&scoped=true"
import script from "./PowerDistribution.vue?vue&type=script&lang=js"
export * from "./PowerDistribution.vue?vue&type=script&lang=js"
import style0 from "./PowerDistribution.vue?vue&type=style&index=0&id=36d58fcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d58fcc",
  null
  
)

export default component.exports